
import { Injectable } from '@angular/core';
import { DataProvider,ParameterService,Widget,DashboardConfigManager,AuthService,LogService } from "core-dashboard";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';



@Injectable()
export class DesigoccObjectValueCloudProvider implements DataProvider {

    widget: Widget;
    config: any;
    objectValueUrl = 'https://cors-anywhere.herokuapp.com/http://device-service-cc-iot.horizon-dev.siemens.io/api/points/';
  
   
    private connectionId :any;

    constructor(private authService: AuthService, 
                private parameterService: ParameterService, 
                private http: HttpClient, 
                private logger : LogService,
                private dashboardConfig: DashboardConfigManager) 
    {
    }

    //this is to get reduced COV data if required
    getReducedCovData(tData:any){

    }
    getData(w: Widget) {
        this.widget = w;
        this.config = this.widget.getConfig();
        try 
        {
             if(this.config == undefined)
            {
                this.logger.logWarning("DesigoccObjectValueCloudProvider" ," Config is missing in widget setup.");
                this.widget.Draw(null);
                return;
            }

            this.GetObjectValue();
        }
        catch (error) {
            this.logger.logError('DesigoccObjectValueCloudProvider', "Error while fetching data. Error:" + error);
            this.widget.Draw(null);
        }
    }

    // this will zoom the widget
    zoom(zoomFrom: any, zoomTo: any) {       
    }   


    private  pointName = "";
    private GetObjectValue() 
    {
      
      if (this.config.pointName) 
        {
            this.pointName = this.parameterService.getParameter(this.config.pointName);
            if(this.pointName == "")
            {
                this.widget.Draw(null);
                throw new Error("Invalid point name in ULR.");
            }
        }

          let url: string =  this.objectValueUrl + this.pointName;

         
        //get token
        let token: any = this.authService.getToken();// window.sessionStorage.getItem("_token");
        let headers: HttpHeaders = new HttpHeaders({"Adapter": "pa-desigocc-adapter","Content-Type": "application/json","Access-Control-Allow-Origin": "*"});
       // headers.append("Adapter", "pa-desigocc-adapter");
      //  headers.append("Content-Type", "application/json");
        //headers.append("Access-Control-Allow-Origin", "*");

        // headers.append('Access-Control-Allow-Origin', 'http://localhost:3000');
        //headers.append('Access-Control-Allow-Credentials', 'true');

        try
        {
      
        this.http.get(url, {headers}).subscribe((res:HttpResponse<any>) => 
            {
                this.logger.logInfo("DesigoccObjectValueCloudProvider" ,"Received response." + res);

                try{
                    if (res.status < 200 || res.status >= 300) 
                    {
                        this.widget.Draw(null);
                        throw new Error("Bad response status: " + res.status);
                    }
                    let body: any = res;//.json();
                    if (body && body.value != undefined) 
                    {
                        let pointvalue =body.value;
                        this.logger.logInfo("DesigoccObjectValueCloudProvider", "Call for drawing widget is initiated");
                        this.widget.Draw(pointvalue);
                    }
                    else
                    {
                        this.logger.logError("DesigoccObjectValueCloudProvider", "Error while processing response for point name " + this.pointName);
                        this.widget.Draw(null);
                    }
                }
            catch(error)
            {
                this.logger.logError("DesigoccObjectValueCloudProvider", "Error in response : " + error);
            }
        },  (error )=>
        {
            //TODO:
            // this section of code was part of processError() method
            //because widget and loggerhelper are losing their references , moving code to inline method
            //this needs more investigation and code refactor
            let errMsg: any = (error && error.statusText) ? error.statusText: "Server error";
            if(this.logger)
                this.logger.logError("DesigoccEventCountersProvider", "Error in received from service: " + errMsg);
            if(this.widget)
                this.widget.Draw(null);
        });
        }
        catch(error)
        {
            if( this.logger)
            this.logger.logError("DesigoccObjectValueCloudProvider", "this is logged by logger" + error); 
        }
    }

    private processError(error: any) 
    {
        let errMsg: any = error.message || "Server error";
        if( this.logger)
            this.logger.logError("DesigoccObjectValueCloudProvider",errMsg); 
        else
            throw new Error("Bad response status: " + errMsg);
            
        if(this.widget)
            this.widget.Draw(null);
    }

    dispose(): void {
        
    }
}



